import { format, getTime, formatDistanceToNow } from 'date-fns';

type InputValue = Date | string | number | null;

export function fDate(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd/MM/yyyy';

  return date ? format(new Date(date), fm) : null;
}

export function fDateTime(date: InputValue, newFormat?: string) {
  const fm = newFormat || 'dd/MM/yyyy HH:mm:ss';

  return date ? format(new Date(date), fm) : null;
}

export function fTimestamp(date: InputValue) {
  return date ? getTime(new Date(date)) : null;
}

export function fToNow(date: InputValue) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : null;
}
